import { combine, sample } from 'effector';
import { debounce } from 'patronum';
import { accountTreeModel } from 'entities/account';
import { createGetDevicePlayersQuery } from 'shared/api';
import { createState } from 'shared/lib';
import { authorizedDeviceRoute } from 'shared/routing';
import { devicePageModel } from './device-page-model';

const getDevicePlayersQuery = createGetDevicePlayersQuery();

const nameFilter = createState('');

const currenciesFilter = createState<string[]>([]);

const isConnectedFilter = createState<boolean[]>([]);

const $deviceId = devicePageModel.$device.map((device) => device?.id ?? null);

const $playersQueryParams = combine({
	deviceId: $deviceId,
	name: nameFilter.$value,
	currencies: currenciesFilter.$value,
	isConnected: isConnectedFilter.$value,
});

const $players = getDevicePlayersQuery.$data.map((players) => players ?? []);

const $playersPending = combine(
	{
		players: getDevicePlayersQuery.$data,
		pending: getDevicePlayersQuery.$pending,
	},
	({ players, pending }) => !players && pending,
);

sample({
	clock: devicePageModel.currentTabState.$value,
	source: $playersQueryParams,
	filter: (params, tab) => tab === 'players' && params.deviceId !== null,
	fn: (params) => ({
		deviceId: params.deviceId as number,
		name: params.name,
		currencies: params.currencies,
		isConnected: params.isConnected,
	}),
	target: getDevicePlayersQuery.start,
});

sample({
	clock: debounce($playersQueryParams, 300),
	source: devicePageModel.currentTabState.$value,
	filter: (tab, params) => tab === 'players' && params.deviceId !== null,
	fn: (_, params) => ({
		deviceId: params.deviceId as number,
		name: params.name,
		currencies: params.currencies,
		isConnected: params.isConnected,
	}),
	target: getDevicePlayersQuery.start,
});

sample({
	clock: authorizedDeviceRoute.closed,
	target: [
		getDevicePlayersQuery.reset,
		nameFilter.$value.reinit,
		currenciesFilter.$value.reinit,
		isConnectedFilter.$value.reinit,
	],
});

export const devicePagePlayersModel = {
	getDevicePlayersQuery,
	$players,
	$playersPending,
	filters: {
		name: nameFilter,
		currencies: currenciesFilter,
		isConnected: isConnectedFilter,
	},
	$currencies: accountTreeModel.$currencies,
};
